<template>
<div id="app" class="download-page page-template-default no-sidebar separate-containers">
  <HeadNav selectedLanguage="en" page="download" :gotodownload="download" />

  <main id="downloadpage">
    <section class="download-hero">
      <div class="download-shell download-hero-shell">
        <h1>Download GB WhatsApp APK</h1>

        <figure class="download-logo">
          <img src="../assets/gblogo2.webp" alt="GB WhatsApp logo" />
        </figure>

        <div class="download-action">
          <button type="button" class="download-btn" @click="downloadfrom('hero')">
            <img src="@/assets/download-line.svg" alt="" />
            Download APK (Latest Version)
          </button>
        </div>

        <p class="download-summary">
          Download the GB WhatsApp APK file and check the latest version, APK size, Android requirements,
          installation details, and available features.
        </p>
      </div>
    </section>

    <article class="download-shell article-shell">
      <section class="content-section">
        <h2>GB WhatsApp APK File Information</h2>
        <p>Before downloading, check the APK details to make sure the file is suitable for your device.</p>
        <div class="info-table">
          <table>
            <tbody>
              <tr v-for="item in fileInfo" :key="item.label">
                <th>{{ item.label }}</th>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="content-section">
        <h2>How to Install GB WhatsApp APK</h2>
        <p>Installing the APK on Android only takes a few steps:</p>
        <ol class="install-list">
          <li v-for="(step, index) in installSteps" :key="step">
            <span class="step-number">{{ index + 1 }}</span>
            <span class="step-text">{{ step }}</span>
          </li>
        </ol>
      </section>

    </article>
  </main>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';

const DEFAULT_DOMAIN = 'gbwtsapp.com';
const DEFAULT_APP_NAME = 'GB_gbwtsapp.com';
const DEFAULT_APK_URL = 'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.19.906_gw.apk';

export default {
  name: 'Download',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'download',
      apk: DEFAULT_APK_URL,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
      fileInfo: [
        { label: 'App Name', value: 'GB WhatsApp' },
        { label: 'File Type', value: 'APK' },
        { label: 'Platform', value: 'Android' },
        { label: 'Latest Version', value: 'GB WhatsApp Latest Version' },
        { label: 'Android Requirement', value: 'Android 5.0+' },
        { label: 'Installation', value: 'Manual APK Installation' },
        { label: 'License', value: 'Free to Download' },
      ],
      installSteps: [
        'Download the GB WhatsApp APK file.',
        'Open the Downloads folder on your Android device.',
        'Tap the downloaded APK file.',
        'Allow installation from the relevant source if Android asks for permission.',
        'Tap Install and wait for the process to finish.',
        'Open GB WhatsApp and complete the account setup.',
      ],
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk || DEFAULT_APK_URL;
          } else {
            this.apk = DEFAULT_APK_URL;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || DEFAULT_DOMAIN,
          appName: appname || DEFAULT_APP_NAME,
        })
        .then((res) => {
          if (res.code == 200) {
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
          }
        });
    },
    download() {
      this.$global.download(DEFAULT_APK_URL);
    },
  },
};
</script>

<style lang="scss" scoped>
#downloadpage {
  min-height: 70vh;
  background: #f6f8f7;
  color: #25332e;
}

.download-shell {
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  padding-left: 32px;
  padding-right: 32px;
  box-sizing: border-box;
}

.download-hero {
  background: #fff;
  border-bottom: 1px solid #dbe8e1;
}

.download-hero-shell {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 46px;
  padding-bottom: 42px;
}

h1 {
  margin: 0 0 18px;
  color: #10261d;
  font-size: 44px;
  font-weight: 800;
  line-height: 1.1;
  text-align: center;
}

.download-logo {
  width: min(160px, 58vw);
  margin: 28px auto 24px;
}

.download-logo img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 0;
  box-shadow: none;
}

.download-action {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 22px;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 54px;
  padding: 0 26px;
  border: 0;
  border-radius: 8px;
  background: #128c62;
  color: #fff;
  font-size: 17px;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(18, 140, 98, 0.24);
}

.download-btn:hover {
  background: #0e7451;
}

.download-btn img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.download-summary {
  max-width: 760px;
  margin: 0;
  color: #40544c;
  font-size: 17px;
  line-height: 1.7;
  text-align: center;
}

.article-shell {
  padding: 32px 0 58px;
}

.content-section {
  padding: 26px 0;
  border-bottom: 1px solid #dde8e2;
}

.content-section:last-child {
  border-bottom: 0;
}

.content-section h2 {
  margin: 0 0 14px;
  color: #15372a;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
}

.content-section p {
  margin: 0 0 16px;
  color: #40544c;
  font-size: 17px;
  line-height: 1.7;
}

.info-table {
  overflow-x: auto;
  margin: 14px 0 16px;
  border: 1px solid #d6e4dd;
  border-radius: 6px;
  background: #fff;
}

.info-table table {
  width: 100%;
  border-collapse: collapse;
}

.info-table th,
.info-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #e8eeeb;
  color: #3d4f48;
  text-align: left;
  vertical-align: middle;
  font-size: 14px;
  line-height: 1.45;
}

.info-table tr:last-child th,
.info-table tr:last-child td {
  border-bottom: 0;
}

.info-table th {
  width: 34%;
  background: #eef7f2;
  color: #15372a;
  font-size: 13px;
  font-weight: 700;
}

.install-list {
  margin: 14px 0 18px;
  margin-left: 0 !important;
  padding: 0;
  list-style: none !important;
  list-style-type: none !important;
}

.install-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 10px;
  padding: 14px 16px !important;
  border: 1px solid #e2ebe6;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(16, 54, 40, 0.04);
  color: #4d5f58;
  font-size: 15px;
  line-height: 1.6;
}

.install-list li::marker {
  content: none;
}

.install-list .step-number {
  display: inline-flex;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #128c62;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
}

.install-list .step-text {
  flex: 1;
  padding-top: 4px;
}

@media (max-width: 820px) {
  h1 {
    font-size: 34px !important;
  }

  h2 {
    font-size: 25px !important;
  }
}

@media (max-width: 520px) {
  .download-shell {
    padding-left: 20px;
    padding-right: 20px;
  }

  .download-btn {
    width: 100%;
    padding: 0 12px;
    font-size: 15px;
  }

  .download-summary {
    font-size: 15px;
  }

  .info-table th,
  .info-table td {
    padding: 7px 10px;
    font-size: 13px;
    line-height: 1.4;
  }
}
</style>
